import { render, staticRenderFns } from "./CustomersClubSetting.vue?vue&type=template&id=0b20b5c4"
import script from "./CustomersClubSetting.vue?vue&type=script&lang=js"
export * from "./CustomersClubSetting.vue?vue&type=script&lang=js"
import style0 from "./CustomersClubSetting.vue?vue&type=style&index=0&id=0b20b5c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports